import _ from 'lodash';

export const getFilterResultsForUser = (user, filters) => _.map(_.keys(filters), filterKey => {
    const filterValue = _.get(filters, filterKey);
    if (!filterValue || filterValue == "") return true;

    if (filterKey === 'entity') {
        const [entityTypeId, entityId] = _.split(filterValue, ':');
        return _.some(_.flatMap(_.map(user.roles, r => _.map(r.entities, e => ({ ...e, entityTypeId: r.entityTypeId })))), entity => `${entity.entityTypeId}` === entityTypeId && `${entity.entityId}` === entityId);
    } else if (filterKey === 'roleId') {
        return _.some(user.roles, r => `${r.roleId}` === `${filterValue}`);
    } else if (filterKey === 'name') {
        return _.includes(_.toLower(`${user.firstName} ${user.lastName}`), _.toLower(filterValue));
    } else if (filterKey === 'emailAdr') {
        return _.includes(_.toLower(user.emailAdr), _.toLower(filterValue));
    }

    return false;
});